import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { selectUsersForNames } from '../../../store/userSelectors';
import { loadUsersMinimalDetails } from '../../../store/userService';
import { formatDateTime } from '../../../utils/dateFunctions';

import local from './formStyles/rowDropdownDetails.module.css';

const FormStatusHistory = ({ history }) => {
    const dispatch = useDispatch();

    // LOCAL STATE
    const [emailAddress, setEmailAddress] = useState('');

    // STORE STATE
    const users = useSelector(selectUsersForNames);

    useEffect(() => {
        if(!users) return;
        if (history.userId) {
            const user = users.find((el) => el.id === history.userId);
            !user
                ? dispatch(loadUsersMinimalDetails([history.userId]))
                : setEmailAddress(user.loginEmailAddress);
        }
    }, [users, history.userId]);

    // RENDER
    return (
        <div className={local.historyRow}>
            <span className={local.label}>{history.action} By: </span>
            <span>{emailAddress}</span>
            <span>{formatDateTime(history.date)}</span>
        </div>
    );
};

FormStatusHistory.propTypes = {
    history: PropTypes.object
};

export default FormStatusHistory;
